// extracted by mini-css-extract-plugin
export default {"main":"collapseSettingComp_main__5ZjAm","hidden":"collapseSettingComp_hidden__BZMex","expanded":"collapseSettingComp_expanded__i7Cd+"};